import { useController } from 'react-hook-form'

import { FormControlLabel, Checkbox, Radio } from '@mui/material'

const CheckboxControlled = (props) => {
  const { name, control, rules, type, ...rest } = props

  const { field, fieldState: { error } } = useController({ name, control, rules })

  return (
    <FormControlLabel
      name={name}
      control={
        type === 'radio'
          ? (<Radio onChange={field.onChange} {...rest} />)
          : (<Checkbox onChange={field.onChange} checked={field.value || false} />)
      }
      {...rest}
    />
  )
}

export default CheckboxControlled
